import { Listbox } from "@headlessui/react";
import { Label } from "../Label";
import { FormControlSize } from "../models";
import { cn } from "../../../utils/cn";

const sizes: Record<FormControlSize, string> = {
  sm: "text-xs",
  md: "text-sm",
  lg: "text-sm",
};
export function ListBoxLabel({
  children,
  vSize = "md",
  required = false,
}: {
  children: React.ReactNode;
  vSize?: FormControlSize;
  required?: boolean;
}) {
  return (
    <Listbox.Label className={cn(sizes[vSize])} as={Label}>
      {children}
      {required && <span className="relative -top-1 ml-[0.1rem] text-orange-600">*</span>}
    </Listbox.Label>
  );
}
